var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcGoogleCalendar24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-google-calendar-24_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-google-calendar-24_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1A73E8",
  d: "M8.275 15.483q-.709-.479-.977-1.4l1.096-.452q.15.568.52.88.371.313.898.312.537 0 .923-.327.387-.327.387-.832 0-.516-.407-.843-.409-.327-1.02-.327h-.633v-1.085h.568q.526 0 .886-.284t.36-.778a.86.86 0 0 0-.322-.703q-.322-.263-.817-.264-.483 0-.767.258a1.5 1.5 0 0 0-.414.633l-1.084-.452q.214-.611.794-1.078t1.48-.468q.667 0 1.198.258t.832.713q.3.457.3 1.025 0 .58-.28.982a1.9 1.9 0 0 1-.687.618v.064c.359.15.65.38.882.687q.343.462.344 1.106t-.327 1.149q-.328.505-.902.794t-1.293.29a2.68 2.68 0 0 1-1.538-.476M15 10.045l-1.197.87-.602-.913 2.159-1.557h.827v7.344H15z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "M18.316 23.998 24 18.314l-2.842-1.263-2.842 1.263-1.263 2.842z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "M4.42 21.159 5.685 24h12.632v-5.685H5.684z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M1.895 0A1.894 1.894 0 0 0 0 1.895v16.42l2.842 1.264 2.842-1.263V5.684h12.632l1.263-2.842L18.316 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#188038",
  d: "M0 18.316v3.79C0 23.153.848 24 1.895 24h3.79v-5.685z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC04",
  d: "M18.315 5.685v12.632H24V5.685l-2.843-1.263z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1967D2",
  d: "M24 5.684v-3.79A1.894 1.894 0 0 0 22.105 0h-3.79v5.684z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-google-calendar-24_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-google-calendar-24_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
})))));
export default SvgIcGoogleCalendar24;